// privatokonomi-messages-part2 translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'pkn.gj.journey.debtFree': 'Helt gjeldfri',
  'pkn.gj.now': 'Nå',
  'pkn.gj.fillRequired': 'Fyll inn navn, restgjeld og rente',
  'pkn.gj.editLoan': 'Rediger lån',
  'pkn.gj.addLoan': 'Legg til lån',
  'pkn.gj.fieldName': 'Navn på lån',
  'pkn.gj.phName': 'F.eks. Boliglån',
  'pkn.gj.fieldLender': 'Långiver / type',
  'pkn.gj.phLender': 'F.eks. Annuitetslån · DNB',
  'pkn.gj.fieldBalance': 'Restgjeld (kr)',
  'pkn.gj.fieldOriginal': 'Opprinnelig lån (kr)',
  'pkn.gj.optionalLower': 'valgfritt',
  'pkn.gj.fieldNominal': 'Nominell rente (%)',
  'pkn.gj.fieldEffective': 'Effektiv rente (%)',
  'pkn.gj.optionalUpper': 'Valgfritt',
  'pkn.gj.fieldTerm': 'Gjenstående måneder',
  'pkn.gj.annuityLoan': 'Annuitetslån',
  'pkn.gj.serialLoan': 'Serielån',
  'pkn.gj.serialHint': 'Serielån: fast avdrag hver måned — terminbeløpet er høyest i starten og synker etter hvert som gjelden faller.',
  'pkn.gj.annuityHint': 'Annuitetslån: like stort terminbeløp gjennom hele løpetiden — avdraget øker mens rentedelen synker.',
  'pkn.gj.postedAs': 'Renter og avdrag på dette lånet vises som «{category}» i Forbruk.',
  'pkn.gj.categoryFallback': 'kategori',
  'pkn.gj.loanFallback': 'Lån',
  'pkn.gj.editNamed': 'Rediger {name}',
  'pkn.gj.observedIn': 'Observert i {count} transaksjoner',
  'pkn.gj.calculatedFrom': 'Beregnet fra låneopplysningene',
  'pkn.gj.observed': 'observert',
  'pkn.gj.highestEffective': 'Høyest effektive rente ({rate}) — koster beregnet {interest} i renter i året.',
  'pkn.gj.highest': 'Høyest rente ({rate}) — koster beregnet {interest} i renter i året.',
  'pkn.gj.laterLoan': 'Rente {rate} · beregnet {interest} i renter per år. Ta dette når de dyrere lånene er nedbetalt.',
  'pkn.gj.bufferFirst': 'Bygg først ferdig kontantbufferen. Det mangler',
  'pkn.gj.bufferFirstSuffix': 'til buffermålet før ekstra nedbetaling bør prioriteres.',
  'pkn.gj.snowA': 'betal minimum på alt, men legg ekstra beløp på',
  'pkn.gj.snowB': 'med {rate} rente først. Når det er nedbetalt, flytter du beløpet til det nest dyreste.',
  'pkn.gj.planTitle': 'Nedbetalingsplan · {name}',
  'pkn.gj.extraPerMonth': '{amount} ekstra i måneden',
  'pkn.gj.makesDebtFree': 'gjør deg gjeldfri på {name}',
  'pkn.gj.earlier': '{time} tidligere',
  'pkn.gj.andKeep': 'og lar deg beholde',
  'pkn.gj.toBank': 'som ellers ville gått til banken i renter.',
  'pkn.gj.activated': 'Aktivert',
  'pkn.gj.tryRecommendation': 'Prøv anbefalingen',
  'pkn.gj.standard': 'Standard',
  'pkn.gj.heroEarlier': 'Du blir gjeldfri tidligere',
  'pkn.gj.heroLonger': 'Dette forlenger løpetiden',
  'pkn.gj.heroDrag': 'Dra i slideren og se hva som skjer',
  'pkn.gj.earlierWord': 'tidligere',
  'pkn.gj.laterWord': 'senere',
  'pkn.gj.interestSaved': 'Spart i renter',
  'pkn.gj.interestMore': 'Mer i renter',
  'pkn.gj.paymentNow': 'Terminbeløp nå',
  'pkn.gj.newMonthlyPayment': 'Ny månedlig betaling',
  'pkn.gj.declines': 'Synker etter hvert som gjelden faller',
  'pkn.gj.standardAmount': 'Standard {amount}',
  'pkn.gj.timeLeft': '{time} igjen',
  'pkn.gj.inSpendingSuffix': 'i Forbruk, så du enkelt kan skille lånet fra resten av utgiftene.',
  'pkn.ov.tone.insight': 'Innsikt',
  'pkn.ov.tone.milestone': 'Milepæl',
  'pkn.ov.tone.opportunity': 'Mulighet',
  'pkn.ov.tone.tax': 'Skatt',
  'pkn.ov.tone.save': 'Spar penger',
  'pkn.ov.tone.alert': 'Varsel',
  'pkn.ov.verdict.healthy': 'Sunn økonomi',
  'pkn.ov.verdict.stable': 'Stabil økonomi',
  'pkn.ov.verdict.needsFollowUp': 'Trenger oppfølging',
  'pkn.ov.stat.finances': 'Økonomi',
  'pkn.ov.stat.potentialSaving': 'Potensiell besparelse',
  'pkn.ov.stat.needsFollowUp': 'Krever oppfølging',
  'pkn.ov.things': '{count} ting',
  'pkn.ov.stat.healthScore': 'Helsescore',
  'pkn.ov.goToTopTask': 'Gå til den viktigste oppgaven',
  'pkn.ov.allDone': 'Alt fullført',
  'pkn.ov.noneYet': 'Ingen ennå',
  'pkn.ov.remainingCount': '{count} igjen',
  'pkn.ov.howAdviceCalculated': 'Slik er rådet beregnet',
  'pkn.ov.showFewer': 'Vis færre gjøremål',
  'pkn.ov.seeAll': 'Se alle gjøremål ({count})',
  'pkn.ov.noNewTasks': 'Ingen nye oppgaver akkurat nå. Last opp flere kontoutskrifter for et sikrere og mer oppdatert bilde.',
  'pkn.ov.allTicked': 'Alt er huket av for i dag. Jeg følger med videre og sier fra når noe skjer.',
  'pkn.ov.doneToday': 'Fullført i dag · {count}',
  'pkn.ov.completed': 'fullført',
  'pkn.ov.hidden': 'skjult',
  'pkn.ov.group.wealth': 'Formue og balanse',
  'pkn.ov.group.cashflow': 'Månedlig kontantstrøm',
  'pkn.ov.preliminary': 'Foreløpig · datagrunnlaget er ufullstendig',
  'pkn.ov.sinceLastMonth': 'siden forrige måned',
  'pkn.ov.bestEver': 'Beste noensinne: {score}',
  'pkn.ov.trendMonths': 'Utvikling siste {count} måneder',
  'pkn.ov.mascotAlt': 'SuperPlumma med voksende plante',
  'pkn.ov.howKpisCalculated': 'Slik er nøkkeltallene beregnet',
  'pkn.ov.kpiExplanation': 'Inn er registrert inntekt. Ut er ordinært forbruk. Netto kontantstrøm er inntekt minus ordinært forbruk, lånebetalinger og sparing/investering. Egne overføringer og kredittkortoppgjør er utelatt. Eiendeler og gjeld kan avstemmes mot registrene på de respektive sidene.',
  'pkn.ov.noScoreA': 'Jeg kan ikke sette en helsescore på økonomien din før jeg har tall å regne på',
  'pkn.ov.noScoreB': 'Last opp en kontoutskrift under Import — så analyserer jeg inntekt, forbruk, sparing og gjeld, og forteller deg hvordan du ligger an.',
  'pkn.ov.andChanged': 'og har endret seg',
  'pkn.ov.points': 'poeng',
  'pkn.ov.thinBasis': 'Merk at grunnlaget fortsatt er tynt — flere importerte måneder gir et sikrere bilde.',
  'pkn.ov.watchExtra': 'Det ene jeg følger ekstra med på, er',
  'pkn.rpt.verdict.strong': 'Sterk måned',
  'pkn.rpt.verdict.solid': 'Solid måned',
  'pkn.rpt.verdict.fine': 'Grei måned',
  'pkn.rpt.verdict.mixed': 'Blandet måned',
  'pkn.rpt.verdict.demanding': 'Krevende måned',
  'pkn.rpt.wholeYear': 'Hele {year}',
  'pkn.rpt.ppVs': '{delta} pp mot {year}',
  'pkn.rpt.pctVs': '{pct} mot {year}',
  'pkn.rpt.empty.bad': 'Uten importerte transaksjoner kan jeg ikke peke på hva som bør forbedres.',
  'pkn.rpt.empty.focus': 'Last opp en kontoutskrift under Import, så skriver jeg en full oppsummering av perioden for deg.',
  'pkn.rpt.empty.good': 'Ingenting å vurdere ennå.',
  'pkn.rpt.empty.lead': 'Jeg har ingen importerte transaksjoner for {period} ennå, så jeg kan ikke skrive en oppsummering av perioden. Last opp en kontoutskrift under Import, så leser jeg av tallene og forteller deg hvordan måneden gikk.',
  'pkn.rpt.moverUp': 'Det som beveget seg mest var {name}, som økte {amount} mot {period}.',
  'pkn.rpt.moverDown': 'Det som beveget seg mest var {name}, som falt {amount} mot {period}.',
  'pkn.rpt.strengthYes': 'Sammenlignet med {period} har du styrket økonomien denne perioden.',
  'pkn.rpt.strengthNo': 'Sammenlignet med {period} har du brukt litt mer av overskuddet denne perioden.',
  'pkn.rpt.rhythm.healthy': 'Det er en sunn rytme å holde på — du bygger trygghet måned for måned.',
  'pkn.rpt.rhythm.fine': 'Det er en grei rytme, men det er rom for å legge til side litt mer.',
  'pkn.rpt.rhythm.low': 'Her er det verdt å se om noe kan frigjøres til sparing neste måned.',
  'pkn.rpt.leadNamed': '{name}, i {period} hadde du {income} inn og {cost} i ordinært forbruk. Etter forbruk, gjeldsbetaling og registrert sparing var netto kontantstrøm {saved}. Registrert sparing utgjorde {rate} % av inntekten.',
  'pkn.rpt.lead': 'I {period} hadde du {income} inn og {cost} i ordinært forbruk. Etter forbruk, gjeldsbetaling og registrert sparing var netto kontantstrøm {saved}. Registrert sparing utgjorde {rate} % av inntekten.',
  'pkn.rpt.good.incomeUp': 'Inntekten økte {pct} mot {year}.',
  'pkn.rpt.good.rateUp': 'Spareraten steg fra {from} % til {to} %.',
  'pkn.rpt.good.costDown': 'Kostnadene falt {pct} — lavere enn samme periode i fjor.',
  'pkn.rpt.good.lessOn': 'Du brukte {amount} mindre på {name}.',
  'pkn.rpt.good.rateHealthy': 'En sparerate på {rate} % er sunn — over den anbefalte grensen på 20 %.',
  'pkn.rpt.good.fixedStable': 'Faste utgifter holder seg stabile gjennom perioden.',
  'pkn.rpt.bad.costUp': 'Kostnadene økte {pct} mot {year}.',
  'pkn.rpt.bad.rateDown': 'Spareraten falt fra {from} % til {to} %.',
  'pkn.rpt.bad.mostUp': '{name} økte mest — {pct} ({amount} mer).',
  'pkn.rpt.bad.incomeLower': 'Inntekten var {pct} lavere enn i fjor.',
  'pkn.rpt.bad.rateLow': 'Spareraten på {rate} % er litt lav — prøv å legge til side mer neste måned.',
  'pkn.rpt.bad.nothing': 'Ingenting stikker seg negativt ut denne perioden.',
  'pkn.rpt.focus.watch': 'Hold et øye med {name} neste måned — det er her forbruket økte mest, og en liten justering gir raskest effekt.',
  'pkn.rpt.focus.biggest': '{name} er din største utgiftspost. Se om noe kan trimmes der uten at hverdagen merker det.',
  'pkn.rpt.focus.continue': 'Fortsett i samme spor neste måned og flytt gjerne litt mer av overskuddet rett til et sparemål.',
  'pkn.rpt.obs.highestIncome': 'Årets høyeste inntekt så langt — {amount}.',
  'pkn.rpt.obs.lowestCost': 'Laveste månedskostnad hittil i år.',
  'pkn.rpt.obs.streak': '{count} måneder på rad med overskudd — du sparer jevnt.',
  'pkn.rpt.obs.deviationOver': 'Forbruket ligger {pct} % over snittet for de tre foregående månedene.',
  'pkn.rpt.obs.deviationUnder': 'Forbruket ligger {pct} % under snittet for de tre foregående månedene.',
  'pkn.rpt.obs.standsOut': '{name} skiller seg ut — {pct} mot {year}.',
  'pkn.rpt.obs.setAside': 'Du la til side {amount} gjennom {year}.',
  'pkn.rpt.obs.yearIncome': 'Årsinntekten er {pct} mot {year}.',
  'pkn.rpt.ask.why': 'Hvorfor endret {name} seg denne perioden?',
  'pkn.rpt.ask.spendingFallback': 'forbruket',
  'pkn.rpt.ask.saveMore': 'Hva bør jeg gjøre for å spare mer?',
  'pkn.rpt.ask.vsLastYear': 'Hvordan ligger jeg an mot i fjor?',
  'pkn.rpt.ask.rateEnough': 'Er spareraten min god nok?',
  'pkn.rpt.ask.whatIfContinue': 'Hva skjer hvis jeg fortsetter sånn?',
  'pkn.rpt.opening': 'Åpner utskrift …',
  'pkn.rpt.monthly': 'Månedlig',
  'pkn.rpt.yearly': 'Årlig',
  'pkn.rpt.off': 'Av',
  'pkn.rpt.monthReport': 'Månedsrapport',
  'pkn.rpt.yearReport': 'Årsrapport',
  'pkn.rpt.basedOnBank': 'privatøkonomi · basert på importerte bankdata',
  'pkn.rpt.comparedWith': 'sammenlignet med {period}',
  'pkn.rpt.writtenForYou': 'Skrevet for deg · {period}',
  'pkn.rpt.askPlaceholder': 'Spør om rapporten …',
  'pkn.rpt.netCashflow': 'Netto kontantstrøm',
  'pkn.rpt.incomeCostPerMonth': 'Inntekt og kostnad per måned · {year}',
  'pkn.rpt.outlookSub': 'Hvis utviklingen fra {period} fortsetter det neste året',
  'pkn.rpt.outlookNoteA': 'Fortsetter du i samme tempo som i {period}, kan netto kontantstrøm bli rundt',
  'pkn.rpt.outlookNoteB': 'det neste året. Små justeringer nå kan gjøre kurven brattere.',
  'pkn.rpt.footerNote': 'Rapportene er generert fra importerte konto- og kortutskrifter. Tidligere år er tilgjengelige så lenge dataene er lest inn. Sammenligningen viser samme periode året før.',
  'pkn.tax.prob.veryLikely': 'Svært sannsynlig',
  'pkn.tax.prob.likely': 'Sannsynlig',
  'pkn.tax.prob.possible': 'Mulig',
  'pkn.tax.prob.uncertain': 'Usikker',
  'pkn.tax.heroTag': 'SuperPlummas skatteoppsummering for {year}',
  'pkn.tax.leadNoEstimate': 'Jeg bruker registrert inntekt, gjeld, formue og familiesituasjon som kontrollgrunnlag for {year}. Jeg viser ikke et estimert skattebeløp uten et komplett, verifisert skattegrunnlag.',
  'pkn.tax.leadEstimateA': 'Jeg har gått gjennom skatteopplysningene dine for {year}. Jeg forventer å redusere skatten din med rundt',
  'pkn.tax.leadEstimateB': 'og jeg har prioritert grepene som betyr mest akkurat nå.',
  'pkn.tax.heroMeta': 'Skatteår {year} · regelsett {rules} · estimater må kontrolleres mot Skatteetaten',
  'pkn.tax.unversioned': 'ikke versjonert',
  'pkn.tax.actionsFound': '{count} grep funnet',
  'pkn.tax.noActionsFound': 'Ingen grep funnet ennå',
  'pkn.tax.returnDeadline': 'Skattemelding · frist 30. april',
  'pkn.tax.noDeductions': 'Ingen fradrag er dokumentert sikkert nok til å beregne en skattefordel. Bruk veiviseren som kontrolliste og sammenlign med Skatteetatens forhåndsutfylte opplysninger og offisielle veiledning.',
  'pkn.tax.provisionalEffect': 'Foreløpig beregnet skatteffekt: {amount}.',
  'pkn.tax.checkpointsFound': '{count} kontrollpunkter funnet.',
  'pkn.tax.onlyCandidatesNote': 'Bare kandidater med tilstrekkelige opplysninger har et beløp. Resten viser hva du må svare på eller dokumentere.',
  'pkn.tax.showSignalTx': 'Vis transaksjonene som ga signalet',
  'pkn.tax.unknownDate': 'Ukjent dato',
  'pkn.tax.missingHeading': 'Dette mangler',
  'pkn.tax.readRule': 'Les regelen hos Skatteetaten',
  'pkn.tax.statusLabel': 'Status',
  'pkn.tax.mustClarify': 'Må avklares',
  'pkn.tax.noOptimisations': 'Ingen skattegrep foreslås uten dokumentert grunnlag og gjeldende regelkilde. Kontroller større disposisjoner med Skatteetatens veiledning eller en autorisert rådgiver.',
  'pkn.tax.effectThisYear': 'Effekt i år ({year})',
  'pkn.tax.disclaimer': 'Forslagene er automatisk genererte estimater basert på dine opplysninger og gjeldende skatteregler. De er ikke individuell skatterådgivning. Du har selv ansvar for innholdet i skattemeldingen — kontakt en autorisert rådgiver ved større disposisjoner.',
  'pkn.tax.reviewEmpty': 'Skattekontrollen går gjennom inntekt, gjeld, formue, investeringer, familie og fradrag og flagger det som mangler eller bør sjekkes. Kontrollen kjører så snart skatteopplysningene er hentet inn.',
  'pkn.tax.level.missing': 'Mangler',
  'pkn.tax.level.check': 'Sjekk',
  'pkn.tax.level.ok': 'OK',
  'pkn.tax.checklist.income': 'Inntekt gjennomgått',
  'pkn.tax.checklist.debt': 'Gjeld gjennomgått',
  'pkn.tax.checklist.wealth': 'Formue gjennomgått',
  'pkn.tax.checklist.investments': 'Investeringer gjennomgått',
  'pkn.tax.checklist.deductions': 'Fradrag gjennomgått',
  'pkn.tax.checklist.family': 'Familieopplysninger gjennomgått',
  'pkn.tax.pointsRemain': 'punkter gjenstår',
  'pkn.tax.pointsLeft': 'punkter igjen',
  'pkn.tax.qualityAssured': '{score} % kvalitetssikret',
  'pkn.tax.missingWhenConnected': 'Når inntekt, gjeld, formue og familieopplysninger er koblet på, viser jeg nøyaktig hva som mangler for full sikkerhet.',
  'pkn.tax.goThere': 'Gå dit',
  'pkn.tw.noInfo': 'Ingen sikre opplysninger er hentet for dette steget ennå. Velg relevante forhold i veiviseren og kontroller dem mot årsoppgaver og skattemeldingen.',
  'pkn.tw.pickAll': 'Velg alt som gjaldt i skatteåret. Valgene styrer hvilke kontrollspørsmål du får.',
  'pkn.tw.situation.enslig': 'Enslig',
  'pkn.tw.situation.gift': 'Gift',
  'pkn.tw.situation.samboer': 'Samboer',
  'pkn.tw.situation.barn': 'Barn',
  'pkn.tw.situation.student': 'Student',
  'pkn.tw.situation.pensjonist': 'Pensjonist',
  'pkn.tw.situation.naering': 'Selvstendig næringsdrivende',
  'pkn.tw.topic.union': 'Jeg betalte fagforeningskontingent',
  'pkn.tw.topic.commuter': 'Jeg overnattet borte på grunn av jobb',
  'pkn.tw.topic.refinancing': 'Jeg refinansierte lån',
  'pkn.tw.topic.debt-interest': 'Jeg hadde lån eller lånekostnader som må kontrolleres',
  'pkn.tw.topic.bsu': 'Jeg satte inn penger på BSU',
  'pkn.tw.topic.ips': 'Jeg satte inn penger på IPS',
  'pkn.tw.topic.gifts': 'Jeg ga gaver til frivillige organisasjoner',
  'pkn.tw.topic.share-loss': 'Jeg solgte aksjer eller verdipapirer med tap',
  'pkn.tw.topic.property-loss': 'Jeg solgte bolig eller fritidsbolig med tap',
  'pkn.tw.topic.rental-costs': 'Jeg hadde skattepliktig utleie',
  'pkn.tw.topic.foreign-tax': 'Jeg betalte skatt i utlandet',
  'pkn.tw.topic.home-office': 'Jeg hadde eget rom kun brukt som hjemmekontor',
  'pkn.tw.topic.actual-work-costs': 'Mine faktiske arbeidskostnader kan være høyere enn minstefradraget',
  'pkn.tw.topic.job-move': 'Jeg flyttet på grunn av ny jobb',
  'pkn.tw.topic.education': 'Jeg betalte arbeidsrelatert utdanning',
  'pkn.tw.topic.doctorate': 'Jeg hadde kostnader ved doktorgradsdisputas',
  'pkn.tw.topic.fisher': 'Jeg jobbet som fisker',
  'pkn.tw.topic.seafarer': 'Jeg jobbet som sjøfolk',
  'pkn.tw.topic.young-worker': 'Skatteetaten trakk meg ut til forsøket med arbeidsfradrag for unge',
  'pkn.tw.topic.co-op-housing': 'Jeg eide bolig i borettslag, boligselskap eller sameie',
  'pkn.tw.topic.foreign-worker': 'Jeg var utenlandsk arbeidstaker',
  'pkn.tw.topic.partial-year': 'Jeg bodde i Norge bare deler av året',
  'pkn.tw.topic.hobby-income': 'Jeg hadde hobby, småjobber eller annen ekstrainntekt',
  'pkn.tw.commuted': 'Jeg reiste mellom hjem og et fast arbeidssted',
  'pkn.tw.fuelNote': 'Drivstoffutgifter brukes bare som et signal. Beregningen bruker korteste avstand og faktiske reisedager. Hjemmekontordager skal ikke telles.',
  'pkn.tw.homeAddress': 'Hjemmeadresse',
  'pkn.tw.workAddress': 'Adresse til fast arbeidssted',
  'pkn.tw.shortestDistance': 'Korteste avstand én vei',
  'pkn.tw.travelDays': 'Faktiske reisedager',
  'pkn.tw.presetFullTime': 'Fulltid · 230 dager',
  'pkn.tw.presetHalfTime': '50 % · 115 dager',
  'pkn.tw.presetCustom': 'Eget antall',
  'pkn.tw.distanceChecked': 'Jeg har kontrollert korteste avstand mellom adressene',
  'pkn.tw.tollFerry': 'Dokumenterte bom-/fergekostnader (kontrolleres separat)',
  'pkn.tw.childrenNote': 'Barn gir ikke automatisk fradrag. Oppgi barn som var 11 år eller yngre ved utgangen av skatteåret, og dokumenterte kostnader til pass og stell.',
  'pkn.tw.childrenUnder12': 'Barn 11 år eller yngre',
  'pkn.tw.childrenSpecial': 'Barn 12+ med særskilt omsorgsbehov',
  'pkn.tw.childcareCosts': 'Dokumenterte kostnader til pass og stell',
  'pkn.tw.navSupport': 'Stønad til barnetilsyn fra NAV',
  'pkn.tw.extraKm': 'Ekstra km per dag til barnepass',
  'pkn.tw.extraDays': 'Dager med ekstra transport',
  'pkn.tw.bankReports': 'Bank og tilbydere rapporterer mye automatisk. Kryss av for forhold som fortsatt må avstemmes.',
  'pkn.tw.deductionsFound': '{count} mulige fradrag eller kontrollpunkter er funnet.',
  'pkn.tw.noCandidates': 'Ingen kandidater er funnet ennå.',
  'pkn.tw.amountsNote': 'Beløp vises bare når grunnlaget kan beregnes. Resten er spørsmål som må kontrolleres.',
  'pkn.tw.finishNote': 'Fullfør betyr at du har gått gjennom spørsmålene – ikke at fradragene er godkjent eller skattemeldingen er klar til innsending.',
  'pkn.tw.sub': 'Omfattende kontroll for skatteåret {year}',
  'pkn.tw.stepWord': 'Steg',
  'pkn.tw.checklistReviewed': 'Skattesjekklisten er gjennomgått',
});
